var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card p-4 text-center"},[_c('h3',{staticClass:"text-muted mb-4",staticStyle:{"font-size":"14px"}},[_vm._v("Incidents")]),_c('apexchart',{attrs:{"height":_vm.heatmapHeight + 'px',"width":"95%","type":"heatmap","series":_vm.selectHeatmapSeries,"options":_vm.chartOptions}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }